import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=6996a828&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=6996a828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996a828",
  null
  
)

export default component.exports